module.exports = __webpack_public_path__ + "img/stackslash-62.1ad753a4.jpg";